import { put, all, takeLatest, select } from "redux-saga/effects";
import {
  REQNotificationList,
  RESNotificationList,
  FailNotificationList,
  SENDxNotification,
  DELxNotification,
  SETxNotificationStatus
} from "./actions";
import * as actions from "../../Authentication/redux/actions";
import { authHeaders, notificationInit, notificationRequest, readError } from "../api";

function* adminSession() {
  const accessToken = yield select(state => state.auth.accessToken);
  const tGUID = yield select(state => state.auth.GUID);
  return authHeaders(accessToken, tGUID);
}

/* GET /api/v1/admin/notifications?search=&status=&page=&limit= */
function* fetchNotificationListWorker({ payload }) {
  try {
    const headers = yield adminSession();
    const filters = payload || {};
    const query = {
      ...(filters.search ? { search: filters.search } : {}),
      ...(filters.status && filters.status !== "ALL" ? { status: filters.status } : {}),
      ...(filters.sendStatus && filters.sendStatus !== "ALL" ? { sendStatus: filters.sendStatus } : {}),
      page: String(filters.page || 1),
      limit: String(filters.limit || 20)
    };

    const call = notificationRequest("list", { query });
    const request = yield fetch(call.url, notificationInit(call, headers));

    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    if (!request.ok) {
      const message = yield readError(request);
      yield put(FailNotificationList({ message }));
      return;
    }

    const response = yield request.json();
    yield put(RESNotificationList(response));
  } catch (error) {
    yield put(FailNotificationList({ message: error.message }));
  }
}

/* POST /api/v1/admin/notifications/:id/send */
function* sendNotificationWorker({ payload }) {
  try {
    const headers = yield adminSession();
    const call = notificationRequest("send", { id: payload.id });
    const request = yield fetch(call.url, notificationInit(call, headers));

    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    if (!request.ok) {
      const message = yield readError(request);
      yield put(FailNotificationList({ message }));
      return;
    }

    yield fetchNotificationListWorker({ payload: payload.filters });
  } catch (error) {
    yield put(FailNotificationList({ message: error.message }));
  }
}

/* DELETE /api/v1/admin/notifications/:id */
function* deleteNotificationWorker({ payload }) {
  try {
    const headers = yield adminSession();
    const call = notificationRequest("remove", { id: payload.id });
    const request = yield fetch(call.url, notificationInit(call, headers));

    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    if (!request.ok) {
      const message = yield readError(request);
      yield put(FailNotificationList({ message }));
      return;
    }

    yield fetchNotificationListWorker({ payload: payload.filters });
  } catch (error) {
    yield put(FailNotificationList({ message: error.message }));
  }
}

/*
 * PUT /api/v1/admin/notifications/:id/status
 *
 * The only change a delivered campaign accepts: deactivating it hides it from every
 * customer's inbox while its Reach / View history stays.
 */
function* setNotificationStatusWorker({ payload }) {
  try {
    const headers = yield adminSession();
    const call = notificationRequest("setStatus", {
      id: payload.id,
      payload: { status: payload.status }
    });
    const request = yield fetch(call.url, notificationInit(call, headers));

    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    if (!request.ok) {
      const message = yield readError(request);
      yield put(FailNotificationList({ message }));
      return;
    }

    yield fetchNotificationListWorker({ payload: payload.filters });
  } catch (error) {
    yield put(FailNotificationList({ message: error.message }));
  }
}

export function* notificationListSaga() {
  yield all([
    takeLatest(REQNotificationList, fetchNotificationListWorker),
    takeLatest(SENDxNotification, sendNotificationWorker),
    takeLatest(DELxNotification, deleteNotificationWorker),
    takeLatest(SETxNotificationStatus, setNotificationStatusWorker)
  ]);
}
